module.exports = __webpack_public_path__ + "static/media/16UNODC29.a491b837.jpg";